import React, { useState } from "react";

const DraggableChart = React.forwardRef(({ id, className, children, onDragStart, onDragOver, onDrop }, ref) => {
  const [isDragging, setIsDragging] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragStart = (e) => {
    e.dataTransfer.setData("chartId", id);
    onDragStart(id);
    setIsDragging(true);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    setIsDragOver(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
    onDragOver(id);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const draggedId = e.dataTransfer.getData("chartId");
    onDrop(draggedId, id);
    setIsDragOver(false);
  };

  return (
    <div
      ref={ref}
      className={`draggable-chart ${className} ${isDragging ? "dragging" : ""} ${isDragOver ? "drag-over" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onDragEnd={handleDragEnd}
    >
      {typeof children === "function" ? children({ handleDragStart }) : children}
    </div>
  );
});

DraggableChart.displayName = "DraggableChart";

export default DraggableChart;
